/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiValidationWorkflowsDropdownListParams = zod.strictObject({
    forms: zod.array(zod.number()).optional(),
    limit: zod.number().optional(),
    name: zod.string().optional(),
    order: zod.string().optional(),
    page: zod.number().optional(),
});

export type ApiValidationWorkflowsDropdownListParams = zod.input<
    typeof ApiValidationWorkflowsDropdownListParams
>;
export type ApiValidationWorkflowsDropdownListParamsOutput = zod.output<
    typeof ApiValidationWorkflowsDropdownListParams
>;
